import {
    HttpClient,
    provideHttpClient,
    withInterceptors
} from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
    MAT_FORM_FIELD_DEFAULT_OPTIONS,
    MatFormFieldDefaultOptions
} from '@angular/material/form-field';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideRouter } from '@angular/router';
import { FwkFormsModule } from '@fwk/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsModule } from '@ngxs/store';
import { provideUiTour } from 'ngx-ui-tour-md-menu';
import { environment } from '../environments/environment';
import { authUnauthorizedInterceptor } from './core/auth/auth-unauthorized.interceptor';
import { authInterceptor } from './core/auth/auth.interceptor';
import { apiErrorInterceptor } from './core/http/api-error.interceptor';
import { AuthState } from './features/auth/auth.state';
import { SubscriptionsState } from './features/subscriptions/subscriptions.state';
import { routes } from './routes';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideNativeDateAdapter(),
        // Interceptor order matters:
        // 1) authInterceptor -> credentials
        // 2) apiErrorInterceptor -> normalize error envelope
        // 3) authUnauthorizedInterceptor -> reacts to 401/403 (step 2 will switch to code-based)
        provideHttpClient(withInterceptors([authInterceptor, apiErrorInterceptor, authUnauthorizedInterceptor])),
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: {
                appearance: 'outline',
                subscriptSizing: 'fixed',
            } as MatFormFieldDefaultOptions
        },
        // Guided tours (ngx-ui-tour-md-menu v16). disablePageScrolling: false evita
        // dejar el scroll bloqueado al terminar/cancelar (problema visto en landing).
        provideUiTour({
            enableBackdrop: true,
            disablePageScrolling: false,
            smoothScroll: true,
            centerAnchorOnScroll: true,
            showProgress: true,
            showArrow: true,
            backdropConfig: {
                // Visual dimming/radius come from .touranchor--is-active box-shadow;
                // keep backdrop only for click-blocking (transparent fill).
                offset: 0,
                backgroundColor: 'transparent'
            }
        }),
        importProvidersFrom(
            FwkFormsModule.forRoot(),
            NgxsFormPluginModule.forRoot(),
            NgxsModule.forRoot([
                AuthState,
                SubscriptionsState
            ]),
            NgxsReduxDevtoolsPluginModule.forRoot({
                disabled: environment.production
            }),
            MatSnackBarModule,
            TranslateModule.forRoot({
                defaultLanguage: 'es',
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient]
                }
            })
        )
    ]
};
